/**
 * Created by Christof Sander on 28.09.2016.
 */

module.exports = {

	events: {
		click: function(event){
			event.preventDefault();
			event.stopImmediatePropagation();

			var component = event.data.component;
			component.performAndStoreAction(
				'openModalInCharge',
				component.prepareAction('openHtmlEditor')
			);
		}
	},

	hooks: {
		onDecision: function($element, options){
			if((((this.actions.openModalInCharge || {}).source || {}).load || {}).component){
				switch(options.decisionType){
					case 'submit':
						var self = this;
						this.actions.openModalInCharge.source.load.component.find('base_form_fields_html-editor', function(htmlEditorComponent){
							// set modified text in model
							self.model.dataTEXT = htmlEditorComponent.getEditorContent();
							// set modified text as preview in div
							self.$.find('.contentPreview').html(self.model.dataTEXT.substr(0,260).replace(/<[a-zA-Z\/][^>]*>/gi, "") + " ...");
						});

						this.parent(function(parentComponent){
							parentComponent.trigger('onChildChanged', {
								fieldCode:  self.model.fieldCode,
								value:      this.model.dataTEXT
							});
						});

						break;

					case 'cancel':
						// do nothing
						break;

					default:
						// TODO: ERROR;
				}

				this.actions.openModalInCharge.source.load.component.hide();
			}
		}
	}
};